export const replaceVarsOnTranslation = (
    phrase: string,
    variables?: (string | number)[],
): string => {
    let newPhrase = phrase;
    if (!Array.isArray(variables) || !variables) return phrase;
    variables.forEach((item, index) => {
        const regexp = new RegExp(`\\\\\\\\\\b${index + 1}\\b`, 'gi');
        newPhrase = newPhrase.replace(regexp, item.toString());
    });
    return newPhrase;
};
